import { Immutable } from "immer";
import React from "react";

import { _RichNavigation__BannerLink as Value } from "@reactivated";

import { RichTextBlock } from "@thelabnyc/thelabui/src/components/RichText";
import { IntrinsicElementProps } from "@thelabnyc/thelabui/src/utils/types";

import { Flair } from "../Flair";

import styles from "./index.module.scss";

type Props = Immutable<{
    value: Value;
}> & {
    attrs?: IntrinsicElementProps<HTMLElement>;
};

export const RichNavigationBannerLink = (
    props: Props,
): React.JSX.Element | null => {
    const isActive =
        !props.value.promo_period || props.value.promo_period.is_promo_active;
    if (!isActive) {
        return null;
    }
    return (
        <a href={props.value.destination?.url} className={styles.bannerLink}>
            {props.value.text && <RichTextBlock value={props.value.text} />}
            {props.value.flair && <Flair flair={props.value.flair} />}
        </a>
    );
};
